module.exports = __webpack_public_path__ + "img/inopei.a5bc469c.png";